import Vue from "vue";
import VueRouter from "vue-router";
import loginView from "../views/loginView.vue";

Vue.use(VueRouter);
function guardMyroute(to, from, next) {
  var isAuthenticated = false;
  if (localStorage.getItem("login")) isAuthenticated = true;
  else isAuthenticated = false;
  if (isAuthenticated) {
    next();
  } else {
    next("/");
  }
}
const routes = [
  {
    path: "/edit-tax-declaration-form/:id",
    name: "Edit Tax Form",
    component: () => import("@/views/TaxDeclarationEditFormView"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/tax-declaration-table",
    name: "Tax Declaration Table",
    component: () => import("@/views/TaxDeclarationTableView"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/tax-declaration-form",
    name: "Create Form Tax Declaration of Real Property",
    component: () => import("@/views/TaxDeclarationCreateFormView"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/taxable-assessment-form",
    name: "Create Form Taxable Assessment Properties",
    component: () => import("../views/TaxableAssessmentCreateFormView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/taxable-assessment-dashboard",
    name: "Taxable Assessment Table",
    component: () => import("../views/TaxableAssessmentDashboardView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/taxable-assessment-edit-form/:id",
    name: "Edit Taxable Assessment Form",
    component: () => import("../views/TaxableAssessmentEditFormView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/exempt-assessment-dashboard",
    name: "Exempt Assessment Table",
    component: () => import("../views/ExemptAssessmentDashboardView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/exempt-assessment-form",
    name: "Create Form Exempt Assessment Properties",
    component: () => import("@/views/ExemptAssessmentCreateFormView"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/edit-exempt-assessment-form/:id",
    name: "Edit Exempt Assessment Form",
    component: () => import("@/components/EditForms/ExemptAssessmentEditForm"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/tax-map-control-dashboard",
    name: "Tax Map Control Table",
    component: () => import("../views/TaxMapControlDashboardView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/tax-map-control-form",
    name: "Create Form Tax Map Control",
    component: () => import("../views/TaxMapControlCreateFormView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/edit-tax-map-control-form/:id",
    name: "Edit Tax Map Control Form",
    component: () => import("../views/TaxMapControlEditFormView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/property-owner-card",
    name: "Create Form Property Owner Card",
    component: () => import("../views/PropertyOwnerFormView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/ownership-record-dashboard",
    name: "Ownership Records",
    component: () => import("../views/OwnershipRecordDashboardView.vue"),
    beforeEnter: guardMyroute,
  },
  // {
  //   path: "/property-owner-card",
  //   name: "PropertyOwnerFormView",
  //   component: () => import("../views/PropertyOwnerFormView.vue"),
  // },
  {
    path: "/edit-ownership-record-dashboard/:id",
    name: "Edit Ownership Record Form",
    component: () => import("../views/PropertyOwnerEditFormView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/",
    name: "Login",
    component: loginView,
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/ProfilePageView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/WebLandingPageView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/user-control-dashboard",
    name: "User Control",
    component: () => import("../views/UserControlDashboardView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/edit-user/:id",
    component: () => import("../components/Users/EditUserControl.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/ownership-record-dashboard",
    name: "OwnershipRecordDashboardView",
    component: () => import("../views/OwnershipRecordDashboardView.vue"),
    beforeEnter: guardMyroute,
  },
  // {
  //   path: "/property-owner-card-dashboard",
  //   name: "PropertyOwnerCardView",
  //   component: () => import("../views/PropertyOwnerCardView.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
